const doc = [({"ja":({"tpi":"TPI", "trip":"Trip", "his":"HIS", "surprice":"Surprice", "expedia":"Expedia", "airline":"航空会社HP", "other":"その他", "arc":"Arc", "kronos":"Kronos"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;